import { useFileExport } from './use-file-export';
import { getContactData } from '../components/user-contact-table/table-toolbar/contactsDownload/functions';
import { ProspectDto } from '@zaplify/prospects';

export const useContactExport = () => {
    const { downloadCSV, downloadExcel } = useFileExport();

    const downloadContacts = async (prospects: ProspectDto[], format: 'csv' | 'xlsx', fileNameEnding = '') => {
        const contactsFormatted = prospects.map((prospect) => getContactData({ ...prospect.data, id: prospect.id }));
        if (format === 'csv') {
            downloadCSV(contactsFormatted, 'prospects' + fileNameEnding);
        } else {
            downloadExcel(contactsFormatted, 'prospects' + fileNameEnding);
        }
    };

    return { downloadContacts };
};
